import { Component } from '@angular/core';

@Component({
  selector: 'app-terms',
  templateUrl: './terms.component.html',
})
export class TermsComponent {
  language: 'is' | 'en' = 'is'; // Default to Icelandic

  setLanguage(lang: 'is' | 'en') {
    this.language = lang;
  }
}